<template>
  <el-dialog
    v-loading="isLoading"
    :element-loading-text="$t('General.PleaseWaitFor', { action: $t('General.Loading') })"
    element-loading-background="rgba(0, 0, 0, 0.7)"
    :visible.sync="visibleProxy"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="960px"
    class="clubhouse-dialog"
  >
    <span slot="title" class="clubhouse-dialog__title">
      {{ $t('OrderFoodEntry.CommunityHallTitle') }}
    </span>
    <div class="clubhouse-dialog__body">
      <el-tabs
        v-model="activeTab"
        :before-leave="handleBeforeLeaveTab"
        class="clubhouse-dialog__tabs"
      >
        <!-- 會館營業時間 -->
        <el-tab-pane
          v-if="showBusinessTab"
          name="business"
          :label="$t('OrderFoodEntry.ClubhouseBusinessTab')"
        >
          <div class="clubhouse-business">
            <div class="clubhouse-business__body">
              <div class="clubhouse-business__left">
                <!-- 社區會館營業時間 -->
                <div class="clubhouse-business__block">
                  <span class="clubhouse-business__title">
                    {{ $t('OrderFoodEntry.CommunityClubhouseBusinessTab') }}
                  </span>
                  <!-- 週一至週日列表 -->
                  <div class="clubhouse-business__rows">
                    <div
                      v-for="day in businessByWeekday"
                      :key="day.weekDay"
                      class="clubhouse-business__row"
                    >
                      <!-- 週幾 -->
                      <div class="clubhouse-business__weekday">
                        {{ day.weekDayName }}
                      </div>
                      <!-- 營業時間 -->
                      <div class="clubhouse-business__periods">
                        <template v-if="day.isOpen === 1 && day.hourses && day.hourses.length">
                          <span
                            v-for="(range, idx) in day.hourses"
                            :key="idx"
                            class="clubhouse-business__period"
                          >
                            {{ formatTime(range.openTime) }} ~ {{ formatTime(range.closeTime) }}
                          </span>
                        </template>
                        <span
                          v-else
                          class="clubhouse-business__period clubhouse-business__period--empty"
                        >
                          {{ $t('OrderFoodEntry.NonServiceTime') }}
                        </span>
                      </div>
                      <!-- 操作 -->
                      <div class="clubhouse-business__actions">
                        <!-- 編輯 -->
                        <div class="clubhouse-business__edit">
                          <el-button v-if="day.isOpen === 1" type="primary" plain @click="openEditBusinessDialog(day)">
                            {{ $t('OrderFoodEntry.EditBusiness') }}
                          </el-button>
                        </div>
                        <!-- 開關 -->
                        <el-switch
                          v-model="day.isOpen"
                          :active-value="1"
                          :inactive-value="0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clubhouse-business__right">
                <!-- 目前暫定不顯示
                營業前 / 營業結束前的預約點餐
                <div class="clubhouse-business__block top">
                  <div class="clubhouse-business__title">
                    預約限制設定
                  </div>
                  <div class="clubhouse-business__reserve">
                    <div class="clubhouse-business__reserve-item">
                      <span class="clubhouse-business__reserve-text">
                        {{ $t('OrderFoodEntry.BeforeOpenHour') }}
                      </span>
                      <el-select
                        v-model="editReserveBeforeOpenHour"
                        size="small"
                      >
                        <el-option
                          v-for="option in reserveHourOptions"
                          :key="option.value"
                          :label="option.label"
                          :value="option.value"
                        />
                      </el-select>
                      <span class="clubhouse-business__reserve-text">
                        {{ $t('OrderFoodEntry.BeforeOpenHourReserve') }}
                      </span>
                    </div>
                    <div class="clubhouse-business__reserve-item">
                      <span class="clubhouse-business__reserve-text">
                        {{ $t('OrderFoodEntry.BeforeCloseHour') }}
                      </span>
                      <el-select
                        v-model="editReserveBeforeCloseHour"
                        size="small"
                      >
                        <el-option
                          v-for="option in reserveHourOptions"
                          :key="option.value"
                          :label="option.label"
                          :value="option.value"
                        />
                      </el-select>
                      <span class="clubhouse-business__reserve-text">
                        {{ $t('OrderFoodEntry.BeforeCloseHourReserve') }}
                      </span>
                    </div>
                  </div>
                </div>
                -->

                <!-- 指定休息日 -->
                <div class="clubhouse-business__block">
                  <div class="clubhouse-business__title">
                    <span>{{ $t('OrderFoodEntry.DesignatedClosedDays') }}</span>
                    <el-button
                      icon="icon-plus"
                      round
                      class="clubhouse-business__add-holidays"
                      @click="openHolidayDialog"
                    >
                      {{ $t("General.Create") }}
                    </el-button>
                  </div>
                  <div class="clubhouse-business__rows">
                    <div
                      v-if="formattedHolidays.length === 0"
                      class="clubhouse-business__row clubhouse-business__row--empty"
                    >
                      {{ $t('OrderFoodEntry.NoData') }}
                    </div>
                    <div
                      v-for="item in formattedHolidays"
                      :key="item.label"
                      class="clubhouse-business__row holiday"
                    >
                      <span>{{ item.label }}</span>
                      <el-button type="danger" plain @click="editHolidays.splice(item.index, 1)">
                        {{ $t('General.Delete') }}
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 取消 / 儲存 -->
            <div class="clubhouse-business__footer">
              <el-button round @click="handleCancel">
                {{ $t('General.Cancel') }}
              </el-button>
              <el-button type="primary" round @click="handleSaveBusiness">
                {{ $t('General.Store') }}
              </el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- 內用桌號設定 -->
        <el-tab-pane
          name="tables"
          :label="$t('OrderFoodEntry.DineInTableList')"
        >
          <div class="clubhouse-tables">
            <!-- 新增內用桌號 -->
            <div class="clubhouse-tables__input-wrap">
              <span class="clubhouse-tables__input-title">{{ $t('OrderFoodEntry.AddTable') }}</span>
              <div class="clubhouse-tables__input-content">
                <el-input
                  v-model="newTableNo"
                  :placeholder="$t('OrderFoodEntry.TableNoPlaceholder')"
                  maxlength="10"
                  size="small"
                  class="clubhouse-tables__input"
                />
                <el-button
                  size="mini"
                  plain
                  :loading="isAddingTable"
                  @click="handleAddTable"
                >
                  {{ $t('General.Create') }}
                </el-button>
              </div>
            </div>

            <!-- 內用桌號列表 -->
            <div class="clubhouse-tables__table-header">
              <span class="clubhouse-tables__table-title">
                {{ $t('OrderFoodEntry.DineInTableList') }}
              </span>
              <el-button
                v-if="isCommunityOrderFoodAppPickupEnabled"
                size="mini"
                type="primary"
                @click="openPrintDialog"
              >
                {{ $t('OrderFoodEntry.PrintTableQrCode') }}
              </el-button>
            </div>
            <el-table
              :data="clubhouseTables"
              class="clubhouse-tables__table"
            >
              <el-table-column
                type="index"
                width="50"
              />
              <el-table-column
                prop="tableNo"
                :label="$t('OrderFoodEntry.DineInTable')"
              />
              <el-table-column
                :label="$t('OrderFoodEntry.Actions')"
                width="240"
              >
                <template slot-scope="{ row }">
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    class="clubhouse-tables__delete-button"
                    @click="handleDeleteTable(row)"
                  >
                    {{ $t('General.Delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <!-- 出單設定 -->
        <el-tab-pane
          name="print"
          :label="$t('OrderFoodEntry.PrintSettingTab')"
        >
          <div class="clubhouse-print-setting">
            <div class="clubhouse-print-setting__body">
              <div
                v-for="section in printSettingSections"
                :key="section.key"
                class="clubhouse-print-setting__section"
              >
                <span class="clubhouse-print-setting__title">
                  {{ section.title }}
                </span>
                <div class="clubhouse-print-setting__card">
                  <!-- 說明文字與開關 -->
                  <div class="clubhouse-print-setting__row">
                    <span class="clubhouse-print-setting__desc">
                      {{ section.desc }}
                    </span>
                    <el-switch v-model="section.setting.isEnabled" />
                  </div>
                  <!-- 出單張數：開關關閉時隱藏 -->
                  <div
                    v-if="section.setting.isEnabled"
                    class="clubhouse-print-setting__count"
                  >
                    <span class="clubhouse-print-setting__count-label">
                      {{ $t('OrderFoodEntry.PrintCount') }}
                    </span>
                    <el-input-number
                      v-model="section.setting.count"
                      v-readonly-input
                      :min="minFormPrintCount"
                      :max="maxFormPrintCount"
                      size="mini"
                      class="clubhouse-print-setting__input-number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 取消 / 儲存 -->
            <div class="clubhouse-print-setting__footer">
              <el-button round @click="handleCancel">
                {{ $t('General.Cancel') }}
              </el-button>
              <el-button type="primary" round @click="handleSavePrintSetting">
                {{ $t('General.Store') }}
              </el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 營業時間編輯對話框 -->
    <el-dialog
      :visible.sync="isEditBusinessDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      append-to-body
    >
      <span slot="title">
        <div class="clubhouse-edit-business__header">
          <span class="clubhouse-edit-business__title">{{ $t('OrderFoodEntry.ServiceTimeSetting') }} - {{ editingDay.weekDayName }}</span>
          <el-button class="clubhouse-edit-business__add-button" @click="addBusinessRange">
            {{ $t('OrderFoodEntry.AddBusinessOption') }}
          </el-button>
        </div>
      </span>
      <div class="clubhouse-edit-business">
        <div
          v-for="(range, idx) in editingDay.hourses"
          :key="idx"
          class="clubhouse-edit-business__row"
        >
          <span class="clubhouse-edit-business__index">{{ idx + 1 }}. </span>
          <el-time-picker
            v-model="range.openTime"
            :placeholder="$t('OrderFoodEntry.OpenTime')"
            format="HH:mm"
            value-format="HH:mm"
          />
          <span class="clubhouse-edit-business__dash">-</span>
          <el-time-picker
            v-model="range.closeTime"
            :placeholder="$t('OrderFoodEntry.CloseTime')"
            :picker-options="getCloseTimePickerOptions(range.openTime)"
            format="HH:mm"
            value-format="HH:mm"
          />
          <el-button
            v-if="editingDay.hourses && editingDay.hourses.length > 1"
            type="danger"
            icon="el-icon-delete"
            size="mini"
            plain
            circle
            class="clubhouse-edit-business__delete-button"
            @click="removeBusinessRange(idx)"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isEditBusinessDialogVisible = false">
          {{ $t('General.Cancel') }}
        </el-button>
        <el-button type="primary" @click="confirmBusinessEdit">
          {{ $t('General.Confirm') }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 指定休息日對話框（僅骨架，實際日曆元件可後續補充） -->
    <el-dialog
      :visible.sync="isHolidayDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="700px"
      append-to-body
    >
      <span slot="title">
        {{ $t('OrderFoodEntry.HolidayDialogTitle') }}
      </span>
      <div class="clubhouse-holiday">
        <el-calendar
          v-model="holidayCalendarValue"
          class="clubhouse-holiday__calendar"
          :range="holidayCalendarRange"
          :first-day-of-week="1"
        >
          <template
            slot="dateCell"
            slot-scope="{ data }"
          >
            <div
              class="clubhouse-holiday__day"
              :class="{
                'clubhouse-holiday__day--selected': isHolidayDate(data.day),
                'clubhouse-holiday__day--outOfMonth': data.type !== 'current-month',
                'clubhouse-holiday__day--disabled': isHolidayDateOutOfRange(data.day)
              }"
              @click="toggleHolidayDate(data.day)"
            >
              <span class="clubhouse-holiday__day-text">
                {{ data.day.slice(5) }}
              </span>
            </div>
          </template>
        </el-calendar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleHolidayCancel">
          {{ $t('General.Cancel') }}
        </el-button>
        <el-button type="primary" @click="confirmHolidayEdit">
          {{ $t('General.Confirm') }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 列印桌號 QRCode 對話框（僅骨架，印出流程後續提案補） -->
    <el-dialog
      :visible.sync="isPrintDialogVisible"
      width="600px"
      class="clubhouse-print-dialog"
      append-to-body
    >
      <span slot="title">
        {{ $t('OrderFoodEntry.PrintTableQrCode') }}
      </span>
      <div>
        <el-table
          ref="printTableRef"
          :data="clubhouseTables"
          border
          size="small"
          @selection-change="handlePrintSelectionChange"
        >
          <el-table-column
            type="index"
            width="60"
            align="center"
            :label="$t('OrderFoodEntry.TableIndex')"
          />
          <el-table-column
            prop="tableNo"
            :label="$t('OrderFoodEntry.DineInTable')"
            align="center"
          />
          <el-table-column type="selection" width="70" align="center" />
        </el-table>
      </div>
      <div slot="footer" class="clubhouse-print-dialog__footer">
        <!-- <el-button @click="isPrintDialogVisible = false">
          {{ $t('General.Cancel') }}
        </el-button> -->
        <el-button type="primary" @click="handleConfirmPrint">
          {{ $t('OrderFoodEntry.ConfirmPrint') }}
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import dayjs from 'dayjs'
import { ORDER_FOOD_PRINT_TABLE_LIST } from '@/js/utils/orderFood'
import { DEFAULT_FORM_PRINT_COUNT } from '@/store/modules/orderFood'

/** 出單張數下限（Switch 開啟時） */
const MIN_FORM_PRINT_COUNT = 1
/** 出單張數上限 */
const MAX_FORM_PRINT_COUNT = 6

export default {
  name: 'ClubhouseDialog',
  directives: {
    /**
     * 將 el-input-number 內部的 input 設為唯讀，僅能透過「－／＋」調整
     * （el-input-number 未提供 readonly 屬性）
     */
    readonlyInput: {
      inserted (el) {
        const input = el.querySelector('input')
        if (input) input.readOnly = true
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false, // 是否正在加載
      activeTab: 'business',
      editBusinesses: [], // 編輯會館營業時間
      editHolidays: [], // 編輯指定休息日
      editReserveBeforeOpenHour: 0, // 編輯營業前可預約時間
      editReserveBeforeCloseHour: 0, // 編輯營業結束前可預約時間
      businessSnapshot: null, // 會館營業時間分頁初始狀態快照（判斷是否有未儲存修改）
      // 編輯訂單出單設定
      editNormalPrint: {
        isEnabled: true, // 是否出單
        count: DEFAULT_FORM_PRINT_COUNT // 出單張數
      },
      // 編輯異常出單設定（拒單／取消／作廢）
      editAbnormalPrint: {
        isEnabled: true, // 是否出單
        count: DEFAULT_FORM_PRINT_COUNT // 出單張數
      },
      minFormPrintCount: MIN_FORM_PRINT_COUNT, // 出單張數下限
      maxFormPrintCount: MAX_FORM_PRINT_COUNT, // 出單張數上限
      isEditBusinessDialogVisible: false, // 編輯會館營業時間對話框是否顯示
      // 編輯指定休息日
      editingDay: {
        weekDay: null,
        weekDayName: '',
        hourses: []
      },
      holidayCalendarValue: new Date(), // 指定休息日行事曆顯示日期
      holidayCalendarRange: [], // 指定休息日行事曆可顯示範圍
      holidaySelectableMinYMD: '', // 指定休息日可選最小日期
      holidaySelectableMaxYMD: '', // 指定休息日可選最大日期
      holidayDraftHolidays: [], // 指定休息日草稿資料
      holidayOriginalSnapshot: [], // 指定休息日開啟對話框時快照
      isHolidayDialogVisible: false, // 編輯指定休息日對話框是否顯示
      isPrintDialogVisible: false, // 列印桌號 QRCode 對話框是否顯示
      isAddingTable: false, // 新增桌號 loading 狀態
      newTableNo: '', // 新增桌號
      selectedPrintTables: [], // 選擇列印的桌號
      reserveHourOptions: this.buildReserveOptions() // 營業前 / 營業結束前可預約時間選項
    }
  },
  computed: {
    ...mapGetters({
      isCommunityOrderFoodAppPickupEnabled: 'isCommunityOrderFoodAppPickupEnabled'
    }),
    // 代理 visible 屬性
    visibleProxy: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('update:visible', val)
      }
    },
    // 是否顯示會館營業時間 tab（櫃檯＋APP＋通知取餐，isServiceEnabled 64）
    showBusinessTab () {
      return this.$store.getters.isCommunityOrderFoodAppPickupEnabled
    },
    // 會館營業時間
    clubhouseBusinesses () {
      return this.$store.getters.getClubhouseBusinesses || []
    },
    // 會館營業前可預約時間
    clubhouseBeforeOpenHour () {
      return typeof this.$store.getters.getClubhouseBeforeOpenHour === 'number'
        ? this.$store.getters.getClubhouseBeforeOpenHour
        : 0
    },
    // 會館營業結束前可預約時間
    clubhouseBeforeCloseHour () {
      return typeof this.$store.getters.getClubhouseBeforeCloseHour === 'number'
        ? this.$store.getters.getClubhouseBeforeCloseHour
        : 0
    },
    // 指定休息日
    clubhouseHolidays () {
      return this.$store.getters.getClubhouseHolidays || []
    },
    // 內用桌號
    clubhouseTables () {
      return this.$store.getters.getClubhouseTables || []
    },
    // 訂單出單張數（0 表示不出單）
    clubhouseNormalFormPrintCount () {
      return this.$store.getters.getClubhouseNormalFormPrintCount
    },
    // 異常出單張數（0 表示不出單）
    clubhouseAbnormalFormPrintCount () {
      return this.$store.getters.getClubhouseAbnormalFormPrintCount
    },
    // 出單設定分頁的兩個區塊
    printSettingSections () {
      return [
        {
          key: 'normal',
          title: this.$t('OrderFoodEntry.NormalFormPrintSettingTitle'),
          desc: this.$t('OrderFoodEntry.NormalFormPrintSettingDesc'),
          setting: this.editNormalPrint
        },
        {
          key: 'abnormal',
          title: this.$t('OrderFoodEntry.AbnormalFormPrintSettingTitle'),
          desc: this.$t('OrderFoodEntry.AbnormalFormPrintSettingDesc'),
          setting: this.editAbnormalPrint
        }
      ]
    },
    // 週一至週日七列的編輯表單
    businessByWeekday () {
      // 固定顯示週一至週日七列，由 editBusinesses 提供資料來源
      return this.editBusinesses
    },
    // 指定休息日顯示列表（預先格式化日期字串）
    formattedHolidays () {
      return this.editHolidays.map((data, index) => ({
        index,
        label: dayjs(this.getHolidayDateValue(data)).format('YYYY/MM/DD')
      }))
    }
  },
  watch: {
    // 監聽 visible 屬性
    value (val) {
      if (val) {
        this.handleOpen()
      }
    }
  },
  mounted () {
    // 元件掛載後先建立週一至週日七列的編輯表單
    this.initEditState()
  },
  methods: {
    /**
     * 格式化時間
     * @param value {string | Date} 時間值
     * @param withSeconds {boolean} 是否包含秒數
     * @returns {string} 格式化後的時間字串
     */
    formatTime (value, withSeconds = false) {
      if (!value) return ''

      if (value instanceof Date) {
        const hh = String(value.getHours()).padStart(2, '0')
        const mm = String(value.getMinutes()).padStart(2, '0')
        if (!withSeconds) return `${hh}:${mm}`
        const ss = String(value.getSeconds()).padStart(2, '0')
        return `${hh}:${mm}:${ss}`
      }

      const s = String(value)
      const m = s.match(/^(\d{2}):(\d{2})(?::(\d{2}))?/)
      if (!m) return s

      const hh = m[1]
      const mm = m[2]
      if (!withSeconds) return `${hh}:${mm}`

      const ss = m[3] || '00'
      return `${hh}:${mm}:${ss}`
    },
    // 建立營業前 / 營業結束前可預約時間選項
    buildReserveOptions () {
      const options = []
      for (let i = 0; i <= 12; i++) {
        const value = i * 0.5
        options.push({
          value,
          label: value.toString()
        })
      }
      return options
    },
    /**
     * 取得可點選區間今天到兩個月內，以及符合 el-calendar 的顯示範圍
     * @returns {[string, string]}
     */
    getHolidayDateRanges () {
      const today = dayjs().startOf('day')
      const end = today.add(2, 'month')
      const todayDow = today.day()
      const endDow = end.day()

      const displayStart = today.subtract((todayDow + 6) % 7, 'day')
      const displayEnd = end.add((7 - endDow) % 7, 'day')
      return {
        calendarRange: [displayStart.format('YYYY-MM-DD'), displayEnd.format('YYYY-MM-DD')],
        selectableRange: [today.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')]
      }
    },
    /**
     * 從 holiday item 取日期字串
     * @param item {Object}
     * @returns {string}
     */
    getHolidayDateValue (item) {
      return String(item?.HolidayDate || item?.holidayDate || '')
    },
    /**
     * 取得休息日異動清單
     * IsActive = 1 代表新增，IsActive = 0 代表移除
     * @returns {Array<{HolidayDate: string, IsActive: number}>}
     */
    getHolidayDiffPayload () {
      const originalDates = (this.clubhouseHolidays || [])
        .map(item => this.getHolidayDateValue(item))
        .filter(Boolean)
      const editedDates = (this.editHolidays || [])
        .map(item => this.getHolidayDateValue(item))
        .filter(Boolean)

      const originalSet = new Set(originalDates)
      const editedSet = new Set(editedDates)
      const changes = []

      editedSet.forEach(date => {
        if (!originalSet.has(date)) {
          changes.push({
            HolidayDate: date,
            IsActive: 1
          })
        }
      })

      originalSet.forEach(date => {
        if (!editedSet.has(date)) {
          changes.push({
            HolidayDate: date,
            IsActive: 0
          })
        }
      })

      return changes
    },
    /**
     * 建立新 holiday item，盡量沿用現有 key 格式
     * @param holidayDate {string}
     * @returns {Object}
     */
    buildHolidayItem (holidayDate) {
      const sample = this.holidayDraftHolidays[0] || this.editHolidays[0] || this.clubhouseHolidays[0]
      if (sample && Object.prototype.hasOwnProperty.call(sample, 'holidayDate')) {
        return {
          id: null,
          holidayDate
        }
      }
      return {
        Id: null,
        HolidayDate: holidayDate
      }
    },
    /**
     * 判斷日期是否超出可選範圍（今日起至兩個月內）
     * @param day {string} YYYY-MM-DD
     * @returns {boolean}
     */
    isHolidayDateOutOfRange (day) {
      if (!this.holidaySelectableMinYMD || !this.holidaySelectableMaxYMD) return false
      return day < this.holidaySelectableMinYMD || day > this.holidaySelectableMaxYMD
    },
    /**
     * 判斷日期是否為已標記休息日
     * @param holidayDate {string}
     * @returns {boolean}
     */
    isHolidayDate (holidayDate) {
      return this.holidayDraftHolidays.some(item => this.getHolidayDateValue(item) === holidayDate)
    },
    /**
     * 點擊切換休息日標記
     * @param holidayDate {string}
     */
    toggleHolidayDate (holidayDate) {
      if (!holidayDate) return
      const startDate = this.holidaySelectableMinYMD
      const endDate = this.holidaySelectableMaxYMD
      if (!startDate || !endDate) return
      // 判斷日期是否在可選範圍內
      if (holidayDate < startDate || holidayDate > endDate) {
        this.$message.warning(this.$t('OrderFoodEntry.HolidayDateRangeWarning'))
        return
      }
      // 判斷日期是否已標記休息日
      const idx = this.holidayDraftHolidays.findIndex(item => this.getHolidayDateValue(item) === holidayDate)
      if (idx >= 0) {
        // 如果已標記休息日，則移除
        this.holidayDraftHolidays.splice(idx, 1)
        return
      }
      // 如果未標記休息日，則新增
      this.holidayDraftHolidays.push(this.buildHolidayItem(holidayDate))
    },
    // 開啟對話框
    handleOpen () {
      this.isLoading = true
      this.$store.dispatch('fetchClubhouseInfo')
        .then(() => {
          this.initEditState()
        })
        .catch(() => {
          this.$message.error(this.$t('OrderFoodEntry.GetClubhouseInfoFailed'))
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    // 初始化編輯狀態
    initEditState () {
      // 須在切換 activeTab 前重設，避免觸發「未儲存的變更」提示
      this.resetBusinessEditState()
      this.resetPrintEditState()
      this.activeTab = this.showBusinessTab ? 'business' : 'tables'
    },
    // 以 store 資料重設會館營業時間分頁的編輯狀態
    resetBusinessEditState () {
      // 複製會館營業時間資料
      const source = cloneDeep(this.clubhouseBusinesses || [])
      // 固定的週一至週日七列
      const weekdayMeta = [
        { weekDay: 1, weekDayName: this.$t('EvCharging.Monday') },
        { weekDay: 2, weekDayName: this.$t('EvCharging.Tuesday') },
        { weekDay: 3, weekDayName: this.$t('EvCharging.Wednesday') },
        { weekDay: 4, weekDayName: this.$t('EvCharging.Thursday') },
        { weekDay: 5, weekDayName: this.$t('EvCharging.Friday') },
        { weekDay: 6, weekDayName: this.$t('EvCharging.Saturday') },
        { weekDay: 7, weekDayName: this.$t('EvCharging.Sunday') }
      ]
      // 將後端資料初始化為固定的週一至週日七列
      this.editBusinesses = weekdayMeta.map(meta => {
        const found = source.find(item => item.weekDay === meta.weekDay) || {}
        return {
          weekDay: meta.weekDay,
          weekDayName: meta.weekDayName,
          isOpen: typeof found.isOpen === 'number' ? found.isOpen : 0,
          hourses: found.hourses || []
        }
      })
      this.editHolidays = cloneDeep(this.clubhouseHolidays)
      this.editReserveBeforeOpenHour = this.clubhouseBeforeOpenHour
      this.editReserveBeforeCloseHour = this.clubhouseBeforeCloseHour
      this.businessSnapshot = cloneDeep(this.buildBusinessPayload())
    },
    // 以 store 資料重設出單設定分頁的編輯狀態
    resetPrintEditState () {
      this.editNormalPrint = this.toPrintSettingEdit(this.clubhouseNormalFormPrintCount)
      this.editAbnormalPrint = this.toPrintSettingEdit(this.clubhouseAbnormalFormPrintCount)
    },
    /**
     * 出單張數轉為編輯用的開關＋張數
     * @param {number} printCount 出單張數（0 表示不出單）
     * @returns {{ isEnabled: boolean, count: number }}
     */
    toPrintSettingEdit (printCount) {
      const isEnabled = printCount > 0
      return {
        isEnabled,
        // 關閉時後端不保留原張數，重新開啟時帶回預設值
        count: isEnabled ? printCount : DEFAULT_FORM_PRINT_COUNT
      }
    },
    /**
     * 編輯用的開關＋張數轉為出單張數
     * @param {{ isEnabled: boolean, count: number }} setting 編輯中的出單設定
     * @returns {number} 出單張數（0 表示不出單）
     */
    toFormPrintCount (setting) {
      return setting.isEnabled ? setting.count : 0
    },
    // 會館營業時間分頁是否有未儲存修改
    isBusinessDirty () {
      return !isEqual(this.businessSnapshot, this.buildBusinessPayload())
    },
    // 出單設定分頁是否有未儲存修改
    isPrintSettingDirty () {
      return this.toFormPrintCount(this.editNormalPrint) !== this.clubhouseNormalFormPrintCount ||
        this.toFormPrintCount(this.editAbnormalPrint) !== this.clubhouseAbnormalFormPrintCount
    },
    /**
     * 切換分頁前檢查：離開的分頁有未儲存修改時提示，確認後還原該分頁
     * @param {string} activeName 即將切換的分頁
     * @param {string} oldActiveName 目前的分頁
     * @returns {boolean|Promise} 回傳 rejected Promise 時阻止切換
     */
    handleBeforeLeaveTab (activeName, oldActiveName) {
      const leavingTabs = {
        business: {
          label: this.$t('OrderFoodEntry.ClubhouseBusinessTab'),
          isDirty: this.isBusinessDirty,
          reset: this.resetBusinessEditState
        },
        print: {
          label: this.$t('OrderFoodEntry.PrintSettingTab'),
          isDirty: this.isPrintSettingDirty,
          reset: this.resetPrintEditState
        }
      }
      const leavingTab = leavingTabs[oldActiveName]
      if (!leavingTab || !leavingTab.isDirty()) return true

      return this.$confirm(
        this.$t('OrderFoodEntry.UnsavedChangesBody', { tab: leavingTab.label }),
        this.$t('OrderFoodEntry.UnsavedChangesTitle'),
        {
          confirmButtonText: this.$t('General.Confirm'),
          cancelButtonText: this.$t('General.Cancel')
        }
      ).then(() => {
        leavingTab.reset()
      })
    },
    /**
     * 開啟編輯會館營業時間對話框
     * @param day {Object} 週一至週日列表的單一項
     */
    openEditBusinessDialog (day) {
      this.editingDay = cloneDeep(day)
      if (!this.editingDay.hourses) {
        this.editingDay.hourses = []
      }
      this.isEditBusinessDialogVisible = true
    },
    /**
     * 新增營業時間範圍
     */
    addBusinessRange () {
      this.editingDay.hourses.push({
        openTime: '00:00',
        closeTime: '23:59'
      })
    },
    /**
     * 移除營業時間範圍
     * @param idx {number} 營業時間範圍索引
     */
    removeBusinessRange (idx) {
      this.editingDay.hourses.splice(idx, 1)
    },
    /**
     * 將 HH:mm 字串或 Date 轉為分鐘數
     * @param time {string | Date}
     * @returns {number | null}
     */
    timeToMinutes (time) {
      if (!time) return null
      if (time instanceof Date) {
        return time.getHours() * 60 + time.getMinutes()
      }
      const parts = String(time).split(':')
      return parseInt(parts[0]) * 60 + parseInt(parts[1])
    },
    /**
     * 驗證單日營業時段，回傳錯誤類型或 null
     * @param hourses {Array}
     * @returns {'closeBeforeOpen' | 'overlap' | null}
     */
    validateBusinessRanges (hourses) {
      for (let i = 0; i < hourses.length; i++) {
        const start = this.timeToMinutes(hourses[i].openTime)
        const end = this.timeToMinutes(hourses[i].closeTime)
        if (start === null || end === null) return 'closeBeforeOpen'
        if (end <= start) return 'closeBeforeOpen'
        for (let j = i + 1; j < hourses.length; j++) {
          const start2 = this.timeToMinutes(hourses[j].openTime)
          const end2 = this.timeToMinutes(hourses[j].closeTime)
          if (start < end2 && start2 < end) return 'overlap'
        }
      }
      return null
    },
    /**
     * 產生 closeTime picker 的可選範圍（開始時間之後至 23:59）
     * @param openTime {string | Date}
     * @returns {Object}
     */
    getCloseTimePickerOptions (openTime) {
      if (!openTime) return {}
      let hh, mm
      if (openTime instanceof Date) {
        hh = String(openTime.getHours()).padStart(2, '0')
        mm = String(openTime.getMinutes()).padStart(2, '0')
      } else {
        const parts = String(openTime).split(':')
        hh = parts[0] || '00'
        mm = parts[1] || '00'
      }
      return { selectableRange: `${hh}:${mm}:01 - 23:59:59` }
    },
    /**
     * 確認編輯會館營業時間
     */
    confirmBusinessEdit () {
      const error = this.validateBusinessRanges(this.editingDay.hourses)
      if (error) {
        const msgKey = error === 'overlap'
          ? 'OrderFoodEntry.BusinessTimeOverlap'
          : 'OrderFoodEntry.BusinessCloseBeforeOpen'
        this.$alert(this.$t(msgKey), this.$t('General.AlertTitle'), {
          confirmButtonText: this.$t('General.Confirm')
        }).catch(() => {})
        return
      }
      const target = this.editBusinesses.find(item => item.weekDay === this.editingDay.weekDay)
      if (target) {
        target.hourses = this.editingDay.hourses
      }
      this.isEditBusinessDialogVisible = false
    },
    /**
     * 開啟指定休息日對話框
     */
    openHolidayDialog () {
      this.holidayOriginalSnapshot = cloneDeep(this.editHolidays)
      this.holidayDraftHolidays = cloneDeep(this.editHolidays)
      const { calendarRange, selectableRange } = this.getHolidayDateRanges()
      this.holidayCalendarRange = calendarRange
      this.holidaySelectableMinYMD = selectableRange[0]
      this.holidaySelectableMaxYMD = selectableRange[1]
      this.holidayCalendarValue = new Date()
      this.isHolidayDialogVisible = true
    },
    /**
     * 取消編輯指定休息日
     */
    handleHolidayCancel () {
      this.editHolidays = cloneDeep(this.holidayOriginalSnapshot)
      this.isHolidayDialogVisible = false
    },
    /**
     * 確認編輯指定休息日
     */
    confirmHolidayEdit () {
      this.editHolidays = cloneDeep(this.holidayDraftHolidays)
      this.isHolidayDialogVisible = false
    },
    /**
     * 取消對話框
     */
    handleCancel () {
      this.visibleProxy = false
      // 取消不需要更新 store，暫存資料直接丟棄
    },
    /**
     * 保存會館營業時間
     */
    handleSaveBusiness () {
      this.isLoading = true
      const payload = this.buildBusinessPayload()
      this.$store.dispatch('saveClubhouseBusinessAndHoliday', payload)
        .then(() => {
          this.$emit('saved')
          this.visibleProxy = false
          this.$message.success(this.$t('OrderFoodEntry.ClubhouseBusinessSaveSuccess'))
        })
        .catch(() => {
          this.$message.error(this.$t('OrderFoodEntry.ClubhouseBusinessSaveFailed'))
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    /**
     * 組出會館營業時間的儲存資料（亦用於判斷是否有未儲存修改）
     * @returns {Object} 儲存 API 的 payload
     */
    buildBusinessPayload () {
      return {
        ReserveBeforeOpenHour: this.editReserveBeforeOpenHour,
        ReserveBeforeCloseHour: this.editReserveBeforeCloseHour,
        Businesses: this.editBusinesses.map(item => ({
          WeekDay: item.weekDay,
          IsOpen: item.isOpen,
          Hourses: (item.hourses || []).map(range => ({
            OpenTime: this.formatTime(range.openTime, true),
            CloseTime: this.formatTime(range.closeTime, true)
          }))
        })),
        Holidays: this.getHolidayDiffPayload()
      }
    },
    /**
     * 保存出單設定
     */
    handleSavePrintSetting () {
      this.isLoading = true
      const payload = {
        normalFormPrintCount: this.toFormPrintCount(this.editNormalPrint),
        abnormalFormPrintCount: this.toFormPrintCount(this.editAbnormalPrint)
      }
      this.$store.dispatch('saveClubhousePrintSetting', payload)
        .then(() => {
          this.$emit('saved')
          this.visibleProxy = false
          this.$message.success(this.$t('OrderFoodEntry.PrintSettingSaveSuccess'))
        })
        .catch(() => {
          this.$message.error(this.$t('OrderFoodEntry.PrintSettingSaveFailed'))
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    /**
     * 新增內用桌號
     */
    handleAddTable () {
      if (this.isAddingTable) return
      // 判斷桌號是否為空
      const value = (this.newTableNo || '').trim()
      if (!value || value.length === 0) {
        this.$message.error(this.$t('OrderFoodEntry.PleaseEnterTableNo'))
        return
      }
      // 判斷桌號是否已存在
      const isTableExists = this.clubhouseTables.some(item => String(item?.tableNo || '').trim() === value)
      if (isTableExists) {
        this.$message.error(this.$t('OrderFoodEntry.TableNoAlreadyExists', { tableNo: value }))
        return
      }

      this.isAddingTable = true
      this.$store.dispatch('createClubhouseTableNo', { tableNo: value })
        .then(() => {
          this.newTableNo = ''
          this.$message.success(this.$t('OrderFoodEntry.AddTableSuccess'))
        })
        .catch(() => {
          this.$message.error(this.$t('OrderFoodEntry.AddTableFailed'))
        })
        .finally(() => {
          this.isAddingTable = false
        })
    },
    /**
     * 刪除內用桌號
     * @param row {Object} 內用桌號資料
     */
    handleDeleteTable (row) {
      const id = row.id
      if (!id) return
      const tableNo = row.tableNo || ''
      const confirmMessage = this.$t('OrderFoodEntry.DeleteTableConfirm', { tableNo })
      // 顯示確認是否刪除對話框
      this.$confirm(confirmMessage, '提示', {
        confirmButtonText: this.$t('General.Confirm'),
        cancelButtonText: this.$t('General.Cancel'),
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$store.dispatch('deleteClubhouseTableNo', id)
            .then(() => {
              this.$message.success(this.$t('OrderFoodEntry.DeleteTableSuccess'))
            })
            .catch(() => {
              this.$message.error(this.$t('OrderFoodEntry.DeleteTableFailed'))
            })
        })
        .catch(() => {
          // 使用者取消刪除，僅關閉確認框
        })
    },
    /**
     * 開啟列印桌號 QRCode 對話框
     */
    openPrintDialog () {
      this.selectedPrintTables = []
      this.isPrintDialogVisible = true
      this.$nextTick(() => {
        this.$refs.printTableRef?.clearSelection()
      })
    },
    /**
     * 選擇列印的桌號
     * @param rows {Array} 選擇列印的桌號資料
     */
    handlePrintSelectionChange (rows) {
      this.selectedPrintTables = rows
    },
    /**
     * 確認列印桌號 QRCode
     */
    handleConfirmPrint () {
      const tableNoList = (this.selectedPrintTables || [])
        .map(row => row?.tableNo)
        .filter(Boolean)

      if (tableNoList.length === 0) {
        this.$message.error(this.$t('OrderFoodEntry.PleaseSelectToPrintTable'))
        return
      }

      try {
        localStorage.setItem(ORDER_FOOD_PRINT_TABLE_LIST, JSON.stringify(tableNoList))
      } catch (e) {
        this.$message.error(this.$t('OrderFoodEntry.ConfirmPrintFailed'))
        return
      }

      this.isPrintDialogVisible = false
      this.$openNewPageToPath({ name: 'orderFoodTableQrCodePrint' })
    }
  }
}
</script>

<style lang="scss" scoped>
.clubhouse-dialog {
  ::v-deep .el-dialog {
    @include basicDialog;
    width: 850px !important;

    &__header {
      padding-bottom: 20px;
    }
    &__body {
      min-height: 400px;
      max-height: 78vh !important;
      overflow-y: auto !important;
      padding: 16px 24px 0 24px !important;
    }
  }

  ::v-deep .el-tabs {
    @include basicTabs;
    &__header {
      margin: 0 !important;
    }
  }

  &__title {
    font-size: map-get($fontSize, xx-large);
    font-weight: 600;
  }
}

.clubhouse-business {
  display: flex;
  flex-direction: column;
  padding: 24px 12px;

  &__body {
    display: flex;
    gap: 50px;
    padding-bottom: 30px;
  }

  &__left {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  &__block {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &.top {
      margin-bottom: 40px;
    }
  }
  &__title {
    width: 100%;
    font-size: map-get($fontSize, medium);
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  &__rows {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 4px 16px;
    border-radius: 12px;
    border: solid 1px #e5e4e4;
    box-sizing: border-box;
  }
  &__row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    &:not(:last-child) {
      border-bottom: 1px solid #ccc;
    }

    &.holiday {
      padding: 10px 0;
    }

    & .el-button {
      padding: 6px 12px;
    }
  }
  &__weekday {
    font-size: map-get($fontSize, small);
    margin-right: 16px;
  }
  &__periods {
    width: 140px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  &__period {
    font-size: map-get($fontSize, medium);

    &--empty {
      color: #999;
    }
  }
  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }
  &__edit {
    font-size: map-get($fontSize, medium);
    color: $mainColor;
    cursor: pointer;
    text-decoration: underline;
    margin-right: 12px;
  }
  &__add-holidays {
    padding: 8px 14px;
  }

  &__right {
    width: 50%;
  }
  &__reserve {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
  &__reserve-item {
    display: flex;
    align-items: center;

    ::v-deep .el-select {
      width: 70px;
      margin: 0 4px;
      font-size: map-get($fontSize, medium);
    }
  }
  &__reserve-text {
    font-size: map-get($fontSize, medium);
    color: #333;
  }

  &__footer {
    width: 100%;
    padding-top: 24px;
    border-top: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.clubhouse-edit-business {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__title {
    font-size: map-get($fontSize, large);
    font-weight: 600;
  }
  &__add-button {
    font-size: map-get($fontSize, small);
    font-weight: 600;
    color: #fff;
    background-color: $systemBAOrange;
    border-color: $systemBAOrange;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  &__row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }
  &__index {
    width: 18px;
    text-align: right;
    font-size: map-get($fontSize, medium);
    color: #666;
  }
  &__dash {
    padding: 0 4px;
  }
  ::v-deep .el-button {
    &.clubhouse-edit-business__delete-button {
      width: 32px;
      height: 32px;
    }
    & .el-icon-delete {
      padding-right: 0;
    }
  }
}

.clubhouse-holiday__calendar {
  ::v-deep .el-calendar-day {
    padding: 0;
    height: 70px;
  }
  ::v-deep .el-calendar-table {
    td.is-selected {
      background-color: unset;
    }
  }
  ::v-deep .el-calendar__body {
    padding-bottom: 0px;
  }
}

.clubhouse-holiday {
  ::v-deep .el-calendar__header {
    padding: 8px 12px;
  }

  &__day {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  &__day-text {
    font-size: map-get($fontSize, small);
    color: #303133;
  }

  &__day--selected {
    background-color: $whiteHover;

    .clubhouse-holiday__day-text {
      color: $mainColor;
      font-weight: 600;
    }
  }

  &__day--outOfMonth {
    // opacity: 0.45;
  }

  &__day--disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;

    .clubhouse-holiday__day-text {
      color: #c0c4cc;
    }
  }
}

.clubhouse-print-setting {
  display: flex;
  flex-direction: column;
  padding: 24px 12px;

  &__body {
    display: flex;
    flex-direction: column;
    gap: 40px;
    padding-bottom: 30px;
  }
  &__section {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  &__title {
    font-size: map-get($fontSize, medium);
    font-weight: 600;
    color: $mainFontColor;
    text-align: left;
  }
  &__card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 12px;
    border: solid 1px $borderDark2;
    background-color: $defaultColor;
  }
  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  &__desc {
    font-size: map-get($fontSize, medium);
    color: #333;
  }
  &__count {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    border-radius: 8px;
    border: solid 1px $borderDark2;
    background-color: $white;
  }
  &__count-label {
    font-size: map-get($fontSize, medium);
    color: #666;
  }
  &__input-number {
    width: 110px;
  }
  &__footer {
    width: 100%;
    padding-top: 24px;
    border-top: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.clubhouse-tables {
  padding: 24px 12px;

  &__input-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 45px;
  }
  &__input-title {
    font-size: map-get($fontSize, medium);
    font-weight: 600;
    color: $mainFontColor;
    margin-bottom: 8px;
  }
  &__input-content {
    display: flex;
    align-items: center;

    ::v-deep .el-input {
      width: 270px;
      height: 34px;
      margin-right: 4px;

      &__inner {
        height: inherit;
      }
    }
  }

  &__table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
  }

  &__table-title {
    color: $mainFontColor;
    font-size: map-get($fontSize, medium);
    font-weight: bold;
  }

  ::v-deep .el-table {
    @include basicTable;
  }
}

.clubhouse-print-dialog {
  ::v-deep .el-dialog {
    @include basicDialog;

    &__header {
      padding-bottom: 20px;
      font-size: map-get($fontSize, large);
      font-weight: 600;
    }
    &__close {
      font-size: map-get($fontSize, large) !important;
    }
    &__body {
      overflow-y: auto !important;
      padding: 24px !important;
    }
    &__footer {
      padding: 24px !important;
      margin: 0 24px !important;
    }
  }

  ::v-deep .el-table {
    @include basicTable;
  }

  &__footer {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
